import type {
  PageParams,
  PageResponse,
  QueryRequest,
  ResponseItem,
} from './type/account-status-monitor'

function normalizeCustomerId(value?: string) {
  const normalized = String(value ?? '').trim()
  if (!normalized) return undefined

  const numericValue = Number(normalized)
  return Number.isFinite(numericValue) ? numericValue : undefined
}

export function buildQueryRecordPageRequest(params: PageParams): QueryRequest {
  const condition = params.condition ?? {}
  return {
    condition: {
      accountId: condition.accountId,
      accountType: condition.accountType,
      agency: condition.agency,
      amOpenIds: condition.amOpenIds,
      bdOpenIds: condition.bdOpenIds,
      customerId: normalizeCustomerId(condition.merchantId),
      customerName: condition.customerName,
      dateRange: condition.monitorDate,
      eventType: condition.eventType,
      feishuSent: condition.feishuSent,
      followStatus: condition.followUpStatus,
      mediaPlatform: condition.mediaPlatform,
    },
    orderBy: params.orderBy ?? 'DESC',
    pageIndex: params.pageIndex,
    pageSize: params.pageSize,
    sortBy: params.sortBy ?? 'yesterdaySpendUsd',
  }
}

function normalizeRecordResponseItem(item: ResponseItem) {
  return {
    accountId: item.accountId,
    accountName: item.accountName,
    accountType: item.accountType,
    agency: item.agency,
    am: item.amOpenId,
    batch: undefined,
    bd: item.bdOpenId,
    changeReason: item.changeReason,
    correctiveActions: item.correctiveActions,
    currency: item.currency,
    customerName: item.customerName,
    eventType: item.eventType,
    feishuSent: item.feishuSendStatus,
    followUpRemark: item.followRemark,
    followUpStatus: item.followStatus,
    followUpTime: item.followOperatedAt,
    followUpUser: item.followOperator,
    id: String(item.changeLogId),
    last7DaysSpendWithoutToday: item.last7dSpend,
    last7DaysUsdSpendWithoutToday: item.last7dSpendUsd,
    mediaPlatform: item.mediaPlatform,
    merchantId:
      item.customerId === null || item.customerId === undefined
        ? undefined
        : String(item.customerId),
    monitorTime: item.changedAt,
    statusChangedAt: item.changedAt,
    yesterdaySpend: item.yesterdaySpend,
    yesterdayUsdSpend: item.yesterdaySpendUsd,
  }
}

export function mapQueryRecordPageResponse(response: PageResponse | undefined) {
  return {
    items:
      response?.list?.map((item) => normalizeRecordResponseItem(item)) || [],
    total: Number(response?.total ?? 0),
  }
}
